import React from 'react';
import ContactSection from '../components/ContactSection';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <ContactSection />
        </div>
  );
};

export default Contact;
